import "../../styles/atoms.scss";
import DropDownz from "../../ui/atoms/DropDownz";
import Inputz from "../../ui/atoms/Inputz";
import TextAreaz from "../../ui/atoms/TextAreaz";
import SvgIcn from "../../data/IconCompo";
import { useEventRegistrationForm } from "./useEventRegistrationForm";
import {
  JOB_TITLE_OPTIONS,
  RADIO_SAMPLE_OPTIONS,
  CHECKBOX_SAMPLE_OPTIONS,
  PRIVACY_POLICY_URL,
} from "./eventRegistrationConfig";
import "../../styles/EventRegistrationForm.scss";

export default function EventRegistrationForm() {
  const {
    form,
    toggleCheckbox,
    errors,
    touched,
    submitting,
    submitError,
    mode,
    onAnyChange,
    onBlur,
    touchField,
    handleSubmit,
  } = useEventRegistrationForm();

  if (mode === "thanks") {
    return (
      <div className="event-reg-form event-reg-form--thanks" role="status" aria-live="polite">
        <div className="event-reg-form__surface event-reg-form__surface--thanks">
          <div className="event-reg-form__thanks-badge" aria-hidden>
            <SvgIcn name="invitation" />
          </div>
          <h2 className="event-temp-event-body__title event-reg-form__title-row">
            <span className="event-temp-event-body__title-primary">ありがとうございます</span>
            <span className="event-temp-event-body__title-secondary">Thank you</span>
          </h2>
          <p className="event-reg-form__thanks-text">
            お申し込みを受け付けました。確認メールをお送りしましたので、ご確認ください。
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="event-reg-form">
      <div className="event-reg-form__surface">
        <header className="event-reg-form__head">
          <div className="event-reg-form__head-row">
            <div className="event-reg-form__head-badge" aria-hidden>
              <SvgIcn name="event_line" />
            </div>
            <div className="event-reg-form__head-copy">
              <h2 className="event-temp-event-body__title event-reg-form__title-row">
                <span className="event-temp-event-body__title-primary">参加登録</span>
                <span className="event-temp-event-body__title-secondary">Register</span>
              </h2>
              <p className="event-reg-form__intro">
                参加をご希望の方は、以下のフォームよりお申し込みください。<br />
                ご登録いただいたメールアドレス宛に、オンライン参加URLやイベント資料をご案内いたします。
              </p>
            </div>
          </div>
        </header>

        <form className="event-reg-form__form" onSubmit={handleSubmit} noValidate>
          <div className="event-reg-form__panel">
            {/* <h3 className="event-reg-form__panel-title">基本情報</h3> */}
            <div className="event-reg-form__grid">
          <div className="event-reg-form__field" data-has-error={!!(touched.name && errors.name)}>
            <span className="event-reg-form__label">お名前＊</span>
            <Inputz
              iconL="user"
              name="name"
              className="input"
              value={form.name}
              onChange={onAnyChange}
              onBlur={onBlur}
              error={!!(touched.name && errors.name)}
              disable={submitting}
              internationalName
            />
            {touched.name && errors.name ? (
              <div className="event-reg-form__tooltip-error" role="tooltip">
                {errors.name}
              </div>
            ) : null}
          </div>

          <div className="event-reg-form__field" data-has-error={!!(touched.email && errors.email)}>
            <span className="event-reg-form__label">メールアドレス＊</span>
            <Inputz
              iconL="mail"
              name="email"
              type="email"
              className="input"
              value={form.email}
              onChange={onAnyChange}
              onBlur={onBlur}
              error={!!(touched.email && errors.email)}
              disable={submitting}
            />
            {touched.email && errors.email ? (
              <div className="event-reg-form__tooltip-error" role="tooltip">
                {errors.email}
              </div>
            ) : null}
          </div>

          <div className="event-reg-form__field" data-has-error={!!(touched.job_title && errors.job_title)}>
            <span className="event-reg-form__label">職種/役割＊</span>
            <DropDownz
              iconL="job"
              iconR="drop_down"
              iconRHover="drop_up"
              className="dropdown_input event-reg-form__dropdown"
              name="job_title"
              value={form.job_title}
              error={!!(touched.job_title && errors.job_title)}
              onSelect={(payload) => {
                onAnyChange(payload);
                touchField("job_title");
              }}
            >
              {JOB_TITLE_OPTIONS.map((t) => (
                <span key={t}>{t}</span>
              ))}
            </DropDownz>
            {touched.job_title && errors.job_title ? (
              <div className="event-reg-form__tooltip-error" role="tooltip">
                {errors.job_title}
              </div>
            ) : null}
          </div>

          <div className="event-reg-form__field">
            <span className="event-reg-form__label">会社名</span>
            <Inputz
              iconL="company"
              name="company"
              className="input"
              value={form.company}
              onChange={onAnyChange}
              onBlur={onBlur}
              disable={submitting}
            />
          </div>

            </div>
          </div>

          <div className="event-reg-form__panel event-reg-form__panel--soft">
            <div className="event-reg-form__fieldset-stack">
        <div className="event-reg-form__fieldset">
          <legend className="event-reg-form__label">UX/UIデザイン経験</legend>
          <div className="event-reg-form__choice-row">
            {RADIO_SAMPLE_OPTIONS.map((opt) => {
              const selected = form.radio_choice === opt.value;
              return (
                <label key={opt.value} className={`event-reg-form__pill ${selected ? "event-reg-form__pill--on" : ""}`}>
                  <input
                    type="radio"
                    name="radio_choice"
                    value={opt.value}
                    checked={selected}
                    disabled={submitting}
                    onChange={() => {
                      onAnyChange({ name: "radio_choice", value: opt.value });
                      touchField("radio_choice");
                    }}
                    className="event-reg-form__native-control"
                  />
                  <span className="event-reg-form__pill-box" aria-hidden>
                    {selected ? <span className="event-reg-form__pill-mark">✓</span> : null}
                  </span>
                  <span className="event-reg-form__pill-label">{opt.label}</span>
                  {opt.icon ? (
                    <span className="event-reg-form__pill-icon" aria-hidden>
                      <SvgIcn name={opt.icon} />
                    </span>
                  ) : null}
                </label>
              );
            })}
          </div>
        </div>

        <div className="event-reg-form__fieldset">
          <legend className="event-reg-form__label">参加目的</legend>
          <div className="event-reg-form__choice-row">
            {CHECKBOX_SAMPLE_OPTIONS.map((opt) => {
              const checked = (form.check_topics || []).includes(opt.value);
              return (
                <label key={opt.value} className={`event-reg-form__pill event-reg-form__pill--check ${checked ? "event-reg-form__pill--on" : ""}`}>
                  <input
                    type="checkbox"
                    name="check_topics"
                    value={opt.value}
                    checked={checked}
                    disabled={submitting}
                    onChange={() => {
                      toggleCheckbox(opt.value);
                      touchField("check_topics");
                    }}
                    className="event-reg-form__native-control"
                  />
                  <span className="event-reg-form__pill-box event-reg-form__pill-box--square" aria-hidden>
                    {checked ? <span className="event-reg-form__pill-mark">✓</span> : null}
                  </span>
                  <span className="event-reg-form__pill-label">{opt.label}</span>
                  {opt.icon ? (
                    <span className="event-reg-form__pill-icon" aria-hidden>
                      <SvgIcn name={opt.icon} />
                    </span>
                  ) : null}
                </label>
              );
            })}
          </div>
        </div>

        <div
          className="event-reg-form__field event-reg-form__field--full"
          data-has-error={!!(touched.qa_prefill && errors.qa_prefill)}
        >
          <TextAreaz
            title="事前に共有したいご質問があればご記入ください"
            iconL="chat"
            maxLength={800}
            className="custom-input insider event-reg-form__textarea"
            name="qa_prefill"
            value={form.qa_prefill}
            onChange={onAnyChange}
            error={!!(touched.qa_prefill && errors.qa_prefill)}
            onBlur={onBlur}
            disable={submitting}
          />
          {touched.qa_prefill && errors.qa_prefill ? (
            <div className="event-reg-form__tooltip-error" role="tooltip">
              {errors.qa_prefill}
            </div>
          ) : null}
        </div>

        <div className="event-reg-form__field event-reg-form__field--full">
          <span className="event-reg-form__label">このイベントをどこで知りましたか？</span>
          <Inputz
            iconL="globe"
            name="referral_source"
            placeholder="例：SNS、知人の紹介、uud.io など"
            className="input"
            value={form.referral_source}
            onChange={onAnyChange}
            onBlur={onBlur}
            disable={submitting}
          />
        </div>
            </div>
          </div>

        <div className="event-reg-form__footer">
          <div className="event-reg-form__footer-agreements">

            <div data-has-error={!!(touched.notices_ok && errors.notices_ok)}>
              <label
                className={`event-reg-form__privacy ${touched.notices_ok && errors.notices_ok ? "event-reg-form__privacy--error" : ""}`}
              >
                <input
                  type="checkbox"
                  name="notices_ok"
                  checked={!!form.notices_ok}
                  disabled={submitting}
                  onChange={(e) => {
                    onAnyChange({ name: "notices_ok", value: e.target.checked });
                    touchField("notices_ok");
                  }}
                  onBlur={onBlur}
                  className="event-reg-form__native-control"
                />
                <span className="event-reg-form__privacy-box" aria-hidden>
                  {form.notices_ok ? <span className="event-reg-form__pill-mark">✓</span> : null}
                </span>
                <span className="event-reg-form__privacy-text">
                  <a
                    href={PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="event-reg-form__privacy-link"
                  >
                    プライバシーポリシー
                  </a>
                  に同意します。＊
                </span>
              </label>
              {touched.notices_ok && errors.notices_ok ? (
                <div className="event-reg-form__tooltip-error" role="tooltip">
                  {errors.notices_ok}
                </div>
              ) : null}
            </div>
          </div>

          <button
            type="submit"
            className={`event-reg-form__submit ${submitting ? "event-reg-form__submit--disabled" : ""}`}
            disabled={submitting}
          >
            <span>{submitting ? "送信中…" : "送信する"}</span>
            <SvgIcn name="send" className="event-reg-form__submit-icon" />
          </button>
        </div>

        {submitError ? <div className="event-reg-form__submit-error">{submitError}</div> : null}
        </form>
      </div>
    </div>
  );
}
